import VacancyCandidates from './VacancyCandidates.pages';

export default VacancyCandidates;
